<template>
<div class="record-item-wrap">
    <template v-if="type == Constants.RECORD_PAYMENT">
    </template>
    <template v-if="type == Constants.RECORD_CLASS">
    </template>
    <template v-if="type == Constants.RECORD_SHOP">
    </template>
    <div class="title-wrap flex rcb">
        <div class="title">{{ item.stage_con_name || item.stage_name || item.name || '【视频】第150期 众修班—成都站'}}</div>
        <div class="subtitle text-o">{{item.create_time || '2021.07.05'}}</div>
    </div>
    <div class="detail-wrap flex rcb">
        <div class="left-wrap flex rcs">
            <template v-if="type == Constants.RECORD_CLASS">
                <div class="info-item-wrap">
                    <span class="info-text">课程等级：</span>
                    <span class="info-text">{{ item.subject_name}}</span>
                </div>
            </template>
            <template v-else>
                <div class="info-item-wrap">
                    <span class="info-text">缴费：</span>
                    <span class="info-text">{{ item.money}}</span>
                </div>
                <div class="info-item-wrap ml-1">
                    <span class="info-text">提成：</span>
                    <span class="info-text">{{ item.commission_money}}</span>
                </div>
            </template>
        </div>
        <div class="right-wrap">
            <div class="status-text">{{item.status_text || item.is_sign_text || '已确认'}}</div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "studentRecordItem",
    props: ['item', 'type'],
    data() {
        return {

        };
    },
    methods: {
        onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if (!url) return;
            console.log('url---->', url);
            window.location.href = url;
        },

        _onPressToCopy(copyText) {
            this.$copyText(copyText)
                .then((e) => {
                    this.ToastManager('复制成功');
                }, (e) => {
                    console.log('e---->', e);
                })
        },

        async _onPressToDealTicket(check_status) {
            let url = this.API.salon_ticket_check;
            let data = {
                check_status,
                ticket_id: this.item.id,
            };

            let params = {
                title: '温馨提示',
                message: '确定要核销该门票吗？',
            };
            this.AlertManager.confirm(params).then(async () => {
                let result = await this.$post(url, data);
                this.ToastManager(result.msg);
                if (result.code === this.GLOBAL.SUCCESS_CODE) {
                    this.$emit('onRefresh', true);
                }
            });

        }
    },
};
</script>

<style lang="less" scoped>
.record-item-wrap {
    padding: 10px;
    background: #fff;
    border-radius: 5px;
    margin: 10px 15px 0;
    box-sizing: border-box;

    .title-wrap {
        margin-bottom: .5rem;
        
        .title {
            flex: 1;
            color: #333;
            flex-shrink: 0;
            font-weight: 600;
            font-size: 1.4rem;
        }

        .subtitle {
            color: #666;
            font-size: 1.2rem;
        }

    }

    .detail-wrap {        
        .info-text {
            color: #7181eb;
            font-size: 1.3rem;
        }

        .status-text {
            color: #7181eb;
            font-size: 1.2rem;
            border-radius: .2rem;
            background: #f1f3ff;
            padding: .1rem .5rem;
            border: 1px solid #7181eb;
        }

    }

    .btn-wrap {

        .btn-item {
            width: 62px;
            height: 26px;
            color: #fff;
            margin: .5rem 0;
            font-size: 1.2rem;
            border-radius: .5rem;
            background: linear-gradient(205deg, #9cb2f4 1%, #9bb1f4 1%, #6472e8 84%);

            &.cur {
                color: #7181EB;
                background: #fff;
                border: 1px solid #7181EB;
            }
        }

    }
}
</style>
